export default function omitObjectUtil (object, keys = []) {
  const omittedObject = {}
  const strKeys = keys.map(key => key.toString())
  for (const key in object) {
    if (!strKeys.includes(key)) {
      omittedObject[key] = object[key]
    }
  }
  return omittedObject
}
